import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { NavService } from '../../nav.service'
import { MatIconButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { AppLogoComponent } from '../../shared/logo/app-logo.component'
import { HeaderTitleComponent } from '../../shared/header-title.component'
import { ContactSupportIconContainerComponent } from '../../shared/contact-support/contact-support-icon-container/contact-support-icon-container.component'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tracking-header',
  styleUrls: ['./tracking-header.component.scss'],
  templateUrl: './tracking-header.component.html',
  imports: [
    MatIconButton,
    MatIcon,
    AppLogoComponent,
    RouterLink,
    HeaderTitleComponent,
    ContactSupportIconContainerComponent,
  ],
})
export class TrackingHeaderComponent {
  navService = inject(NavService)
  private router = inject(Router)

  @Input() name: string
  @Output() refreshClick = new EventEmitter()

  get subtitle(): string {
    return ''
  }

  onBackClick(): void {
    this.router.navigate(['/home'])
  }
}
